import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { BomLine } from '../../api/models/bom-line';

export class WorksheetProduct {
  partNumber: string;
  qty: number;

  constructor(number: string, qty: number) {
    this.partNumber = number;
    this.qty = qty;
  }
}

@Injectable()
export class OrderService {

  constructor() { }

  private products: WorksheetProduct[] = [];

  $newImportedBomLines = new Subject<BomLine[]>();

  saveWorksheetProduct(product: WorksheetProduct, projectId: string) {
    this.products.push(product);
  }

  getWorksheetProducts() {
    const products = this.products;
    this.products = [];
    return products;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/services/order.service.ts